import { render, staticRenderFns } from "./IcNote.vue?vue&type=template&id=3f87d2c2&scoped=true"
import script from "./IcNote.vue?vue&type=script&lang=js"
export * from "./IcNote.vue?vue&type=script&lang=js"
import style0 from "./IcNote.vue?vue&type=style&index=0&id=3f87d2c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f87d2c2",
  null
  
)

export default component.exports